<template>
  <div>
    <nav-breadcrumb :menu="[{label: '应收质押登记详情'}]"/>
    <pledge-applying-detail-component :detail-data="detailData"></pledge-applying-detail-component>
    <template v-if="detailData.pl__applicationStatus == 'Pending Approval'">
      <form-build
        form-name="approvalForm"
        :form-data="approvalForm"
        :form-rules="approvalFormRules"
        :form-columns-group="approvalFormColumnsGroups"
        :form-buttons="approvalFormButtons"
      ></form-build>
    </template>
    <button-back></button-back>
  </div>
</template>

<script>
  import PledgeApplyingDetailComponent from '../../components/PledgeApplyingDetailComponent'
  import FormBuild from '../../../components/FormBuild'
  import ButtonBack from '../../../components/ButtonBack'
  import xhr from '../../../utils/xhr'

  export default {
    name: "ServerAdminPledgeApplyingView",
    data() {
      return {
        tabName: 'CustomerSummary',
        detailData: {
          invoices: [],
          files: []
        },
        approvalForm: {
          "pl__applicationId": this.$route.query['pl.applicationId'],
          "a__approvingStatus": "",
          "a__remarks": ""
        },
        approvalFormRules: {

        },
        approvalFormColumnsGroups: [
          {
            label: '质押申请审核',
            columns: [
              {
                label: '审核意见',
                component: 'el-input',
                type: 'textarea',
                field: 'a__remarks',
                span: 24
              }
            ]
          }
        ],
        approvalFormButtons: [
          {
            label: '审核通过',
            type: 'primary',
            clickHandler: ($refs)=>{
              this.updateCustomerApplyingPledge($refs, 'Approved')
            }
          },
          {
            label: '否决',
            // type: 'primary',
            clickHandler: ($refs)=>{
              this.updateCustomerApplyingPledge($refs, 'Rejected')
            }
          }
        ]
      }
    },
    mounted() {
      this.getCustomerApplyingPledgeDetail()
    },
    components: {
      PledgeApplyingDetailComponent,
      ButtonBack,
      FormBuild
    },
    computed: {
      filterOption: function () {
        return this.$route.query
      },
      detailFilesData: function () {
        return {
          data: this.detailData.files,

        }
      }
    },
    methods: {
      getCustomerApplyingPledgeDetail: function () {
        xhr.getCustomerApplyingPledgeDetail(
          Object.assign(
            this.filterOption,
            {}
          ),
          res=>{
            try{
              if(res.data.status == 'success') {
                this.detailData = res.data.data
                this.detailData.invoices = this.detailData.invoices.filter(item=>item['pi__invoiceId'])
              }
            }catch(e){}
          })
      },
      updateCustomerApplyingPledge: function ($refs, approvalStatus) {
        this.approvalForm.a__approvingStatus = approvalStatus

        $refs.validate(valid=>{
          if(approvalStatus == 'Rejected' || valid) {
            xhr.updateCustomerApplyingPledge(
              this.approvalForm,
              res=>{
                try{
                  if(res.data.status == 'success') {
                    this.$router.push({name:'ServerAdminPledgeApplyingList'})
                  }
                }catch (e) {

                }
              }
            )
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lender/ServiceAdmin/PledgeApplyingDetail.vue